import { render, staticRenderFns } from "./SettingsTermsOfService.vue?vue&type=template&id=40a397bc"
import script from "./SettingsTermsOfService.vue?vue&type=script&lang=ts"
export * from "./SettingsTermsOfService.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports